<template>
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="py-3 d-flex">
          <div>
            <PrintPage></PrintPage>
            <ExcelExport
                :dataProp="currentUnclosedInvoiceList"
                :columnProp="currentUnclosedInvoiceListHeaders"
                :fileNameProp="this.currentProp ? 'Cari Stok Hareketleri ' + this.currentProp.code + ' ' + this.currentProp.name : ''"
            >

            </ExcelExport>

          </div>

          <div class="ms-auto">
            <v-text-field
                v-model="searchText"
                class="mt-5 pt-3"
                outlined
                rounded
                dense
                placeholder="Arama Yapın..."
                clearable
                hide-details
                append-icon="mdi-magnify"
                @click:append="searchListWithText()"
                @keydown.enter="searchListWithText()"
            >

            </v-text-field>
          </div>
        </div>
        <div>
          <b-table
              :items="currentUnclosedInvoiceList"
              :fields="currentUnclosedInvoiceListHeaders"
              hover
              small
              responsive
              sort-icon-left
              :busy="currentUnclosedInvoiceListLoading"
              id="sectionToPrint"
              show-empty
              head-row-variant="info"
              table-variant="white"
          >
            <template #empty="scope">
              <h6 class="text-center my-5">
                {{ scope.loading ? "Lütfen Bekleyin" : noCurrentMessage ? noCurrentMessage : "Veri Bulunamadı" }}
              </h6>
            </template>
            <template #cell(invoiceDate)="data">
              {{ formattedDate(data.item.invoiceDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(expiryDate)="data">
              {{ formattedDate(data.item.expiryDate, "DD-MM-YYYY") }}
            </template>
            <template #cell(invoiceAmount)="data">
              {{ numberConverter(data.item.invoiceAmount) }}
            </template>
            <template #cell(unclosedAmount)="data">
              {{ numberConverter(data.item.unclosedAmount) }}
            </template>
            <template #cell(remainingAmount)="data">
              {{ numberConverter(data.item.remainingAmount) }}
            </template>
            <template #table-busy>
              <div class="text-center">
                <b-spinner
                    variant="primary"
                    size="lg"
                    label="Lütfen Bekleyin..."
                ></b-spinner>
              </div>
            </template>
          </b-table>
          <!--
          <div class="row">
            <div class="col-lg-12 mb-5">
              <v-pagination
                  v-model="currentPage"
                  circle
                  class="my-4"
                  :length="currentListMetaData.totalPages"
                  :total-visible="10"
              ></v-pagination>
            </div>
          </div>
          -->

        </div>
      </div>
    </div>

  </div>

</template>

<script>


import {mapState, mapActions, mapMutations} from "vuex";
import {numberConverter, printView} from "../../../../helpers";
import {formattedDate} from "@/momentHelper";
import PrintPage from "@/components/shared/PrintPage";
import ExcelExport from "@/components/shared/ExcelExport";

export default {
  components: {
    ExcelExport,
    PrintPage
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    currentProp: {
      type: Object,
      default: () => {
      }
    }
  },
  computed: {
    ...mapState("current", ["currentUnclosedInvoiceList", "currentUnclosedInvoiceListHeaders", "currentUnclosedInvoiceListLoading", "noCurrentMessage"]),
    ...mapState("auth", ["user"])
  },
  mounted() {
    this._fetchCurrentUnclosedInvoiceList();
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      searchText: "",
    };
  },
  methods: {
    ...mapActions("current", ["fetchCurrentUnclosedInvoiceList"]),
    ...mapMutations("current", ["setCurrentUnclosedInvoiceList"]),
    printView,
    formattedDate,
    numberConverter,
    async _fetchCurrentUnclosedInvoiceList() {
      this.fetchCurrentUnclosedInvoiceList({
        params: {},
        body: {
          currentCode: this.user.userInfo.erpCode,
          ...(!(this.searchText === "" || this.searchText === null)) && {documentNumber: this.searchText}
          // ...(!(this.searchText === "" || this.searchText === null)) && {SearchText: this.searchText}
        }
      });
    },
    searchListWithText() {
      this._fetchCurrentUnclosedInvoiceList()
    },
  },
  watch: {}
};
</script>